{
  "nl": {
    "help": {
      "headings": {
        "additionalModelsNote": "Daarnaast zijn er nog andere modellen met verschillende eigenschappen beschikbaar.",
        "contact": "Stond jouw vraag er niet bij?",
        "contactSubtitle": "Neem contact met ons op - we helpen je graag verder.",
        "currentTextModels": "Huidige tekstmodellen",
        "free": "Deze limieten gelden voor jou met je huidige licentie:",
        "imageModels": "Beeldmodellen",
        "imageModelsIntro": "Deze modellen kunnen afbeeldingen genereren op basis van tekstbeschrijvingen.",
        "ttsModels": "Tekst-naar-spraakmodellen",
        "ttsModelsIntro": "Deze modellen kunnen tekst omzetten in natuurlijk klinkende spraak.",
        "transcriptionModels": "Transcriptiemodellen",
        "transcriptionModelsIntro": "Deze modellen kunnen audio-opnamen transcriberen naar tekst.",
        "languageModelIntro": "Fobizz biedt verschillende AI-modellen aan. Hierbij worden altijd zo actueel en krachtig mogelijke modellen geïntegreerd. Voorwaarde is altijd dat modellen compatibel zijn met onze privacyvoorwaarden en dat er voldoende capaciteit is voor de vereisten van fobizz. Omdat nieuwe modellen door de aanbieders op onregelmatige tijdstippen worden uitgebracht, is er geen vaste cyclus - wij controleren elk nieuw model tijdig en integreren het zodra aan de genoemde voorwaarden is voldaan.",
        "languageModelVideoIntro": "Welk model past bij mijn taak?",
        "languageModelVideoDescription": "In de volgende video leggen we de verschillen uit tussen open en gesloten modellen, snelle kleine modellen en krachtige redeneermodellen - en wanneer welk model het beste geschikt is.",
        "languageModels": "Tekstmodellen",
        "largeModel": "Een groot model",
        "largeModelDescription": "levert gedetailleerdere antwoorden. Dit model is bijzonder geschikt voor vragen die meer detaildiepte en het verwerken van grotere verbanden vereisen.",
        "limits": "Limieten",
        "modelCards": "Overzicht AI-modellen",
        "modelTypesIntro": "Fobizz geeft de voorkeur aan open modellen en beveelt in de AI-chat altijd twee alternatieven in deze volgorde aan:",
        "openSourceLanguageModels": "Open source modellen",
        "plugins": "Plugins",
        "proprietaryLanguageModels": "Propriëtaire modellen",
        "reasoningModel": "Een redeneermodel",
        "reasoningModelDescription": "heeft bijzondere analytische vaardigheden. Dit model is bijzonder geschikt voor complexe taken die meerstaps logische denkprocessen en conclusies vereisen.",
        "references": "Bronnen",
        "searchResults": "Zoekresultaten",
        "smallModel": "Een klein model",
        "smallModelDescription": "is bijzonder snel en efficiënt. Dit model is bijzonder geschikt voor snelle dialogen, inhoudelijke taken en eenvoudige antwoorden.",
        "subtitle": "Tips en antwoorden van het fobizz-team",
        "welcome": "Welkom bij fobizz Help"
      },
      "chatbot": {
        "title": "Stel je vraag aan de Helpcenter-chatbot",
        "description": "Stel je vraag aan onze chatbot, die je informatie kan geven over alle onderwerpen rond fobizz en de fobizz-tools.",
        "url": "https://app.fobizz.com/ai/chats/public_assistants/d6272da2-35ae-4b68-8594-14a0da9d4029?token=ef7ab9adca3e758f0aa7d6808605c6a9"
      },
      "labels": {
        "articles": "0 artikelen | 1 artikel | {count} artikelen",
        "contextWindow": "Contextvenster",
        "input": "Invoer",
        "knowledgeCutoff": "Kennisgrens",
        "lastUpdated": "Laatst bijgewerkt op",
        "maxTokens": "Maximale tokens",
        "modelCardUrl": "Referentiedocumentatie",
        "opensInNewTab": "opent in nieuw tabblad",
        "reasoning": "Redeneren",
        "recommended": "Aanbevolen",
        "searchResults": "Vragen & antwoorden"
      },
      "links": {
        "allCategories": "Alle categorieën",
        "backToHelp": "Terug naar Help"
      },
      "paragraphs": {
        "contactEmail": "Stuur ons een e-mail.",
        "contactPhone": "Bel ons: ma t/m vr 8-16 uur",
        "contactSales": "Adviesgesprek inplannen",
        "contactSchoolLicense": "Voor vragen over schoollicenties",
        "disclaimer": "Alle hier vermelde taalmodellen worden gehost in <strong>Europese</strong> of <strong>Duitse</strong> datacenters - met uitzondering van de modellen van <strong>OpenAI</strong> en <strong>Anthropic</strong>.",
        "intro": "Met een gratis account kun je fobizz vrijblijvend testen, een deel van de cursuscatalogus gebruiken en ontvang je een maandelijkse limiet voor de tools.",
        "outro": "Eenmaal aangemaakte inhoud kun je ook na het einde van een abonnement of schoollicentie blijven gebruiken. Exacte informatie over de voorwaarden van de verschillende fobizz-aanbiedingen vind je in de <a href=\"https://plattform.fobizz.com/preistabelle\" target=\"_blank\">prijstabel</a>.",
        "plugins": "Alle modellen die compatibel zijn met plugins hebben automatisch toegang tot de volgende integraties. De volgende plugins zijn momenteel beschikbaar en kunnen de mogelijkheden van AI-assistenten aanzienlijk verbeteren.",
        "recommendedForHelp": "De suggesties zijn gebaseerd op je <a href=\"{profileSettingsUrl}\" target=\"_blank\">profielinstellingen</a>.<br>Pas ze gerust aan."
      },
      "search": {
        "noResults": "Helaas zijn er geen exacte resultaten gevonden. Probeer een ander trefwoord of een andere spelling."
      },
      "table": {
        "contextWindow": "Contextvenster",
        "featureNames": "Functies",
        "maxTokens": "Maximale tokens",
        "model": "Model",
        "openSource": "Open",
        "provider": "Provider",
        "reasoning": "Redeneren",
        "supportsFunctions": "Plugins",
        "supportsVision": "Beeldverwerking",
        "supportsImageGeneration": "Generatie",
        "sizes": "Groottes"
      }
    }
  }
}
